import React, { useState, useEffect } from "react";

import {
    Box,
    Paper,
    Divider,
    TextField,
    Grid,
    Switch,
    FormControlLabel,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    Card,
    styled,
    Chip,
    ListItemText,
    Checkbox,
    OutlinedInput
} from '@mui/material';

import { useFormik } from 'formik';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from "react-router-dom"
import CommonBreadcumbs from '../../common/CommonBreadcumbs';
import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonRestricted from '../../common/CommonRestricted';
import { useAppContextFeatures } from "../../../context/AppContext";

import { spliceString } from "../../../utils/formatString";

import { useAuthAccess } from "../../../hooks/useAuthAccess";
import { useSystemRoutes, routeTypes } from '../../../hooks/useSystemRoutes';
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from '../../../hooks/usePermissions';

import { useRates, rateTypes, targetTypes as rateTargetTypes } from '../../../hooks/api/useRates';
import { useLocations, locationTypes, targetTypes as locationTargetTypes } from '../../../hooks/api/useLocations';
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { initialValues, validationSchema } from "../../../schema/rates/shipping/shippingRateSchema";
import { useTranslations } from "../../../hooks/useTranslations";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export default function NewShippingRate({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@rate"] })

    const { promptMessage } = useSystemPrompt();
    // const { getLocationIds, setLocationIds } = useAppContextFeatures();

    const { isLoading, create } = useRates({ rateType: rateTypes.shippingRate, targetType: rateTargetTypes.shippingRate });
    // const { list: listLocation } = useLocations(locationTypes.location, locationTargetTypes.location);
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.rate.id, scopeTypes.rate.shippingRate.id)

    const navigate = useNavigate();
    const { getRoute } = useSystemRoutes(routeType);
    const { getHtmlHead } = useSystemHead(routeType)
    const [dataLocations, setDataLocations] = useState([])

    const { authData, getAvailableLocations } = useAuthAccess();
    const availableLocations = getAvailableLocations();

    const onSubmit = async (currentValues) => {

        try {

            let data = {
                rate: {
                    rate_name: currentValues?.rateName,
                    scope_id: currentValues?.locationId,
                    scope_type: "location",
                    description: currentValues?.description,
                    status: currentValues?.status ? 1 : 0,
                },
            }

            const response = await create({ data });

            promptMessage(true, `${response?.message}`)
            navigate(getRoute("settings/shippingRates"))

        } catch (error) {
            promptMessage(false, `Action Failed. (${error?.message})`)
        }

    }
    const formik = useFormik({
        initialValues,
        validationSchema,
        enableReinitialize: true,
        onSubmit
    });

    const { values, errors, touched, handleChange, setFieldValue } = formik;

    const RenderLocation = () => {

        if (!values) return <></>

        return (
            <>
                <FormControl
                    margin="dense"
                    fullWidth
                    size="small"
                    error={touched.locationId && Boolean(errors.locationId)}
                >
                    <InputLabel id="location">{t('location')}</InputLabel>
                    <Select
                        labelId="locationId"
                        label={t("location")}
                        name={"locationId"}
                        onChange={(event) => {
                            setFieldValue(`locationId`, event.target.value)
                        }}
                        value={values.locationId ? values.locationId : ""}
                    >
                        {
                            availableLocations?.map((i, index) => {
                                return (
                                    <MenuItem key={index} value={i.id}>
                                        {/* <ListItemText 
                                                primary={`${i.location_name}`}
                                            /> */}
                                        {i.location_name}

                                    </MenuItem>
                                )
                            })
                        }
                    </Select>
                    <FormHelperText>
                        {touched.locationId && errors.locationId}
                    </FormHelperText>
                </FormControl>
            </>
        )
    }

    const RenderForm = () => {

        return (

            <form onSubmit={formik.handleSubmit}>
                <StyledCard>
                    <Grid container spacing={0.5}>
                        <Grid item xs={12} sm={12} md={3} textAlign={"left"}>

                            <CommonSectionHeader
                                title={t('rateInfo')}
                                subTitle={t('detailsOfShippingRateCharges')}
                            />

                        </Grid>
                        <Grid item xs={12} sm={12} md={9}>

                            <Grid container spacing={1}>
                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        autoFocus
                                        fullWidth
                                        name={"rateName"}
                                        label={t("rateName")}
                                        type="text"
                                        variant="outlined"
                                        value={values.rateName}
                                        onChange={handleChange}
                                        error={touched.rateName && Boolean(errors.rateName)}
                                        helperText={touched.rateName && errors.rateName}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    <FormControlLabel
                                        sx={{
                                            marginLeft: '1px'
                                        }}
                                        control={
                                            <Switch
                                                sx={{
                                                    mt: 1
                                                }}
                                                name="status"
                                                checked={Boolean(values.status)}
                                                onChange={(event, checked) => {
                                                    setFieldValue("status", checked);
                                                }}
                                            />
                                        }
                                        label={
                                            Boolean(values.status) ? t("enabled") : t("disabled")
                                        }
                                    />
                                </Grid>

                                <Grid item xs={12} sm={12} md={6}>
                                    {
                                        RenderLocation()
                                    }
                                    {/* <FormControl
                                        margin="dense"
                                        fullWidth
                                        size="small"
                                        error={touched.locationId && Boolean(errors.locationId)}
                                    >
                                        <InputLabel id="locationId">Location</InputLabel>
                                            <Select
                                                labelId="locationId"
                                                label="Location"
                                                name={"locationId"}
                                                onChange={(event) =>{
                                                        setFieldValue("locationId",event.target.value)
                                                    }
                                                }
                                                value={values.locationId}
                                                sx={{
                                                    textAlign: 'left'
                                                }}
                                            >
                                                
                                                {
                                                    calculationTypes.map((i, index) => {
                                                        return (
                                                            <MenuItem key={index} value={i}>{i}</MenuItem>
                                                        )
                                                    })
                                                }

                                            </Select>
                                            <FormHelperText>
                                                {touched.locationId && errors.locationId}
                                            </FormHelperText>
                                    </FormControl> */}
                                </Grid>

                                <Grid item xs={6}>
                                    <TextField
                                        margin="dense"
                                        size="small"
                                        fullWidth
                                        name={"description"}
                                        label={t("description")}
                                        type="text"
                                        variant="outlined"
                                        value={values.description}
                                        onChange={handleChange}
                                        error={touched.description && Boolean(errors.description)}
                                        helperText={touched.description && errors.description}
                                    />
                                </Grid>

                                <Grid item xs={6}>
                                    {/* <Item>xs=4</Item> */}
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </StyledCard>

                <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                    <Grid item md={12} textAlign={"right"}>
                        <LoadingButton
                            type="submit"
                            // fullWidth
                            variant="contained"
                            sx={{
                                mt: 3,
                                mb: 2
                            }}
                            loading={isLoading}
                        >
                            {t('saveChanges')}
                        </LoadingButton>
                    </Grid>
                </Grid>
            </form>

        )
    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.newRate })
            }

            <CommonBreadcumbs
                pageTitle={t('newShippingRate')}
                breadcrumbs={[
                    {
                        displayText: t("shippingRates"),
                        props: {
                            // underline: "hover",
                            href: getRoute("settings/shippingRates")
                        }
                    },
                    {
                        displayText: t("newShippingRate"),
                        props: {
                            color: 'secondary.main'
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageNew.id }) ?
                    RenderForm()
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}